(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterPropertiesMultiPathDialog() {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerPropertiesMulti/printerPropertiesMultiPathDialog/printerPropertiesMultiPathDialog.template.html',
      link: function(scope) {


        scope.portProtocol = scope.context.portProtocol;


        scope.portProtocol.setPathOption();

        scope.changePath = (pathOption) => {
          switch (pathOption) {
            case 'ROOT':
              scope.portProtocol.ippSupportedPath = '/';
            break;
            case 'IPP_PRINT':
              scope.portProtocol.ippSupportedPath = '/ipp/print';
            break;
            case 'ENTER_PATH':
              scope.portProtocol.ippSupportedPath = null;
            break;
          }
        }

        scope.validatePath = function () {
          scope.portProtocol.isValid = scope.portProtocol.validatePortProtocol();
        }

      }
    };
  }

  pxPrinterPropertiesMultiPathDialog.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxPrinterPropertiesMultiPathDialog', pxPrinterPropertiesMultiPathDialog);

})();
